import { CustomResponeData } from 'axios'
import http from '../axios/index'

// 必填 appKey
export enum CUSTOMER_SERVICE_APPKEY {
  edu = 'zhenguo_zhenguokefu_smart_MSAPPXSTQYRK',
}
/**
 * 必填
 * 会话咨询页=1
 * 订单提交页=2
 * 旅程列表页=3
 * 旅程详情页=4
 */
export enum CUSTOMER_SERVICE_PAGESOURCE {
  consulting = 1,
  submiting,
  list,
  details,
}

export interface I_CUSTOMER_SERVICE_CONFIG {
  // 用户加密参数
  accessToken: string
  // 业务方参数id，目前主要是订单id(FAQ推荐场景必填，其他场景选填)
  referId: string
  // 用户的定位信息，由`citiyId_cityName`拼接而成
  locCity: string
}

export interface I_CUSTOMER_SERVICE_RESULT {
  // 跳转客服页面的链接
  url: string
}

// API-获取跳转客服页url
export const getCustomerServiceUrl: (params: {
  appKey: CUSTOMER_SERVICE_APPKEY | string
  pageSource: CUSTOMER_SERVICE_PAGESOURCE
  config?: I_CUSTOMER_SERVICE_CONFIG
}) => Promise<string | undefined> = ({ appKey, pageSource, config }) => {
  return http
    .post<CustomResponeData<I_CUSTOMER_SERVICE_RESULT>>('/corder/api/v1/csc/accessIn', {
      appKey,
      pageSource,
      ...config,
    })
    .then((res) => {
      return res?.url
    })
}
